import React from 'react';
import styled from 'styled-components';
import moment from 'moment';

import { useLanguage } from '../../../../Context/LanguageContext';
import { useTheme } from '../../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../../Styles/theme';

export default function PartnerGymHoldingAndExtendHistoryInfoView(props) {
  const { data } = props;

  const { t } = useLanguage();

  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;

  function calcDataStatus() {
    if (data.status === '연장 추가') return t('partnerGym.history.extensionAdd');
    else {
      if (moment(data.startDate).isAfter(moment())) return t('partnerGym.history.holdingScheduled');
      else if (moment(data.endDate).isAfter(moment())) return t('partnerGym.history.holdingInProgress');
      else return t('partnerGym.history.holdingCompleted');
    }
  }

  function calcDate() {
    return moment(data.startDate).format(t('partnerGym.history.dateFormat')) + " - " + moment(data.endDate).format(t('partnerGym.history.dateFormat'))
  }

  function calcDays() {
    return (moment(data.endDate).diff(data.startDate, 'day') + 1) + t('partnerGym.history.daySuffix');
  }

  function calcFontColor() {
    return theme.historyText;
  }

  function calcBackgroundColor() {
    return theme.buttonFill3;
  }

  return (
    <TopLevelWrapper>
      <ComponentBox backgroundColor={calcBackgroundColor()}>
        <TotalTextWrapper>
          <TextWrapper width={80}>
            <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={calcFontColor()} cursor='pointer'>{calcDataStatus()}</Text>
          </TextWrapper>
          <TextWrapper width={135}>
            <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={calcFontColor()} cursor='pointer'>{calcDate()}</Text>
          </TextWrapper>
          <TextWrapper width={75}>
            <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={calcFontColor()} cursor='pointer'>{calcDays()}</Text>
          </TextWrapper>
          <TextWrapper width={370}>
            <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={calcFontColor()} cursor='pointer'>{data.reason}</Text>
          </TextWrapper>
        </TotalTextWrapper>
      </ComponentBox>
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-end;
  align-items: flex-start;

  width: 100%;
`;

const ComponentBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-end;

  margin-top: -35px;

  width: 836px;
  height: 87px;

  border-radius: 0px 0px 12px 12px;
  background-color: ${props => props.backgroundColor};

  transition: all 0.3s ease-in-out;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const TotalTextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  margin-left: 20px;
  margin-bottom: 16px;

  gap: 10px;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  margin-right: 8px;

  width: ${props => props.width}px;
  height: 20px;

  overflow: hidden;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  @media (hover: hover) {
    &:hover {
      cursor: ${props => props.cursor};
    }
  }
`;
